<template>
  <div class="main-feed pt-10 ml-5 mr-5" v-bind:style="{'zoom': '80%'}">
    <v-overlay :value="isLoading">
        <v-progress-circular 
            indeterminate color="orange"
            :size="70" :width="7"
        ></v-progress-circular>
    </v-overlay>
    <div>
        <v-row>
            <v-col class="col-6">
                <v-card>
                    <v-card-title>
                       {{title}}
                    </v-card-title>  
                    <v-card-text>                  
                        <v-select                            
                            :items="programsTypes"
                            v-model="selectedProgram"                            
                            item-text="name"
                            item-value="code"
                            v-on:change="programInfo = null"
                            label="Program"
                            ></v-select>
                        <p v-if="!!programInfo && !!programInfo.lastProcessedAt">
                            Certificates generated on {{$dateUtils.formatDateTime(programInfo.lastProcessedAt)}}
                            <br/> {{programInfo.dogsCount}} dogs and {{programInfo.showsCount}} shows to process
                        </p>         
                    </v-card-text>        
                    <v-card-actions>
                        <v-btn 
                            color="primary" 
                            v-on:click="getProgramInfo"                            
                            :disabled="!selectedProgram"
                            >Program info
                        </v-btn>&nbsp;&nbsp;
                        <v-btn 
                            color="primary" 
                            v-on:click="processShowResults"                       
                            :disabled="!selectedProgram"
                            >Execute
                        </v-btn>&nbsp;&nbsp;
                    </v-card-actions>    
                </v-card>
                <v-card class="mt-6">
                    <v-card-title>
                      <v-row>
                        <v-col>
                        Cerfiticate generation info
                        <v-spacer />
                        </v-col>
                        <v-col>
                        <v-text-field
                          v-model="certGenSearch"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                        </v-col>
                      </v-row>  
                    </v-card-title>  
                    <v-card-text>     
                       <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" dismissible type="error"> {{ errorMessage }}</v-alert>             
                       <v-data-table 
                          show-group-by
                          :search="certGenSearch"
                          :headers="certGenInfoHeaders" 
                          :items="certGenInfosList" 
                          dense
                          :items-per-page="-1"
                          fixed-header
                          height="75vh"
                          >                  
                          <template v-slot:item.progressDogsCount="{ item }">
                              <v-progress-linear
                                v-if="item.progressDogsCount != item.processedDogsCount"
                                color="orange"
                                height="50"
                                :value="(item.progressDogsCount/item.processedDogsCount)*100.0"
                              >
                              <template v-slot:default="{ value }">
                                <strong class="pl-2 pr-2">{{ item.progressDogsCount }} /{{ item.processedDogsCount }} </strong>
                              </template>                              
                            </v-progress-linear>
                            <v-progress-linear
                                v-else
                                color="light-green"
                                height="25"
                                value="100"
                              >
                              {{ item.processedDogsCount }}
                            </v-progress-linear>
                          </template>
                          <template v-slot:item.processedShowResultsEnteredAfter="{ item }">
                              <span>{{ $dateUtils.formatDateTimeConcise(item.processedShowResultsEnteredAfter) }}</span>
                          </template>
                          <template v-slot:item.requestedAt="{ item }">
                              <span>{{ $dateUtils.formatDateTimeConcise(item.requestedAt) }}</span>
                          </template>
                          <template v-slot:item.processingCompletedAt="{ item }">
                              <span v-if="item.processingCompletedAt">
                                {{ $dateUtils.formatDateTimeConcise(item.processingCompletedAt) }}
                              </span>
                          </template>
                          <template v-slot:item.processingStartedAt="{ item }">
                              <span v-if="item.processingCompletedAt">
                                {{ $dateUtils.formatDurationHumanReadable(item.processingStartedAt, item.processingCompletedAt) }}
                              </span>
                          </template>
                          <template v-slot:item.id="{ item }">                              
                            <a v-if="item.id" v-on:click="showDogsDetails(item)">Details</a>&nbsp;&nbsp;
                          </template>
                          <template v-slot:item.canBeApproved="{ item }">
                              <a v-if="item.canBeApproved" v-on:click="approve(item.id)">Approve</a>
                              <span v-if="item.isApproved">Approved</span>
                          </template>
                          <template v-slot:item.canBePrinted="{ item }">
                              <a v-if="item.canBePrinted && !item.isPrinted" v-on:click="preview(item.id)">Preview Small</a><br/>
                              <a v-if="item.canBePrinted && !item.isPrinted" v-on:click="previewFull(item.id)">Preview Large</a>
                              <a v-if="item.canBePrinted && item.isPrinted" v-on:click="printAgain(item.id)">Print Small</a><br/>
                              <a v-if="item.canBePrinted && item.isPrinted" v-on:click="printAgainFull(item.id)">Print Large</a>
                              <br/>
                              <a v-if="item.canBePrinted" v-on:click="previewLabels(item.id)">Print labels</a>
                          </template>
                          <template v-slot:item.isPrinted="{ item }">
                              <a v-if="item.canBePrinted && !item.isPrinted" v-on:click="markPrinted(item.id)">Mark printed</a>
                              <span v-if="item.isPrinted">Printed</span><br/>
                              <span v-if="item.canBePrinted && item.isPrinted && !item.areNamesUpdated">Updating names 
                                <strong class="pl-2 pr-2">{{ item.progressUpdateNamesDogsCount }} /{{ item.processedDogsWithNewCertsCount }} </strong></span>
                              <span v-if="item.areNamesUpdated">Names updated</span><br/>
                          </template>
                          <template v-slot:item.errors="{ item }">
                              <p>{{item.errors}}</p>
                          </template>
                      </v-data-table>
                    </v-card-text>   
                </v-card>
            </v-col> 
            <v-col>
                <v-card v-if="displayDogDetails">
                    <v-card-title>
                        <v-col>
                        Dogs details
                        </v-col>
                        <v-col>
                        <filter-pills
                          :pills="filters"
                          :toggle="changeFilters"
                          class="hidden-sm-and-down"
                        />
                        </v-col>
                        <v-col>
                        <v-text-field
                          v-model="dogsDetailsSearch"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                        </v-col>
                    </v-card-title>  
                    <v-card-text>               
                       <v-data-table 
                          :search="dogsDetailsSearch"
                          :headers="certGenDogsInfoHeaders" 
                          :items="filteredCertGenDogsInfosList" 
                          dense
                          :items-per-page="-1"
                          fixed-header
                          height="95vh"
                          >    
                          <template v-slot:item.certificatesMissing="{ item }">
                            <div>
                              <span v-for="(cert,idx) in item.certificatesMissing">
                                <span>
                                  Title: {{cert.title}}
                                </span><br/>  
                                <span>
                                  Show date: {{$dateUtils.formatDate(cert.dateAwarded)}}
                                </span>  
                                <span v-if="!!cert.dateGenerated">
                                  <br/>
                                  Generated: {{$dateUtils.formatDate(cert.dateGenerated)}}
                                </span> 
                                <v-divider v-if="!!item.certificatesMissing  && idx < (item.certificatesMissing.length - 1)"></v-divider>
                              </span> 
                            </div>
                          </template>
                          <template v-slot:item.certificatesNew="{ item }">
                            <div>
                              <span v-for="(cert,idx) in item.certificatesNew">
                                <span>
                                  Title: {{cert.title}}
                                </span><br/>  
                                <span>
                                  Show date: {{$dateUtils.formatDate(cert.dateAwarded)}}
                                </span>  
                                <span v-if="!!cert.dateGenerated">
                                  <br/>
                                  Generated: {{$dateUtils.formatDate(cert.dateGenerated)}}
                                </span>
                                <v-divider v-if="!!item.certificatesNew && idx < (item.certificatesNew.length - 1)"></v-divider> 
                              </span>
                            </div>
                          </template>
                          <template v-slot:item.dogId="{ item }">
                            <a v-if="item.dogId" 
                              :href="`/admin/titling/review/${selectedGenInfo?.programName}?dogId=${encodeURIComponent(item.dogId.trim())}`"
                              target="_blank"
                              >{{item.dogId}}</a>
                          </template>
                      </v-data-table>
                    </v-card-text>   
                </v-card>
                <v-dialog v-model="displayPrintPreview">
                    <viewer v-if="displayPrintPreview"
                      :reportName="Report_Name"
                      :dataUrl="Report_URL"
                    />
                </v-dialog>                
            </v-col>
        </v-row>   
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
import adminTitlingService from "@/services/admin/titlingService";
import FilterPills from "@/components/Layouts/FilterPills.vue";
import Viewer from '@/components/Admin/Reports/ReportViewer.vue';
import { MetaNames } from "@/constants";

export default Vue.extend({
  name: "TitlingProcess",
  components: {
    FilterPills,
    Viewer
  },
  data: function () {
      return {
      title:MetaNames.AdminCertificateGeneration,
      Report_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
      Report_URL: '`/Admin/reports/certificates/${this.displayExecutionId}/suffix"`',    
      displayDogDetails: false,
      displayPrintPreview: false,
      displayExecutionId: null,
      isLoading: false,      
      programsTypes: [
          <object>{code: 'A', name: 'Agility'},
          <object>{code: 'R', name: 'Rally'},
          <object>{code: 'O', name: 'Obedience'},
          <object>{code: 'T', name: 'Tracking'},
          <object>{code: 'ST', name: 'Stockdog'},
          <object>{code: 'FT', name: 'Farm Trial'},
          <object>{code: 'RT', name: 'Ranch Trial'},
          <object>{code: 'C', name: 'Conformation'},
          <object>{code: 'SP', name: 'Specialty'},
          <object>{code: 'SD', name: 'Scent Detection'},
        ] as any[],
      selectedProgram: '',
      programInfo: {} as any,
      errorMessage: '',
      certGenSearch: '',
      dogsDetailsSearch: '',
      certGenExecutionInfoId: null,
      certGenInfosList: [] as any[],
      certGenDogsInfosList: [] as any[],
      filteredCertGenDogsInfosList: [] as any[],
      selectedGenInfo: null,
      certGenInfoHeaders: [
        { text: "Program", align: "left", value: "programName", width: "50px" },
        { text: "Progress", align: "left", value: "progressDogsCount", width: "20px", groupable: false }, 
        { text: "Results from", align: "left", value: "processedShowResultsEnteredAfter", width: "120px" }, 
        { text: "New", align: "left", value: "processedDogsWithNewCertsCount", width: "20px" }, 
        { text: "Dev", align: "left", value: "processedDogsWithMissingCertsCount", width: "20px" }, 
        { text: "Err", align: "left", value: "processedDogsWithExceptionsCount", width: "20px" }, 
        { text: "", align: "left", value: "id", width: "50px", groupable: false },  
        { text: "", align: "left", value: "canBeApproved", width: "50px", groupable: false },    
        { text: "", align: "left", value: "canBePrinted", width: "50px", groupable: false },      
        { text: "", align: "left", value: "isPrinted", width: "50px", groupable: false },   
        { text: "Processing Duration", align: "left", value: "processingStartedAt", width: "30px", groupable: false },   
        { text: "Requested at", align: "left", value: "requestedAt", width: "80px", groupable: false },
        { text: "Requested by", align: "left", value: "requestedBy", width: "80px" },
        { text: "Processed at", align: "left", value: "processingCompletedAt", width: "80px" },   
        { text: "Errors", align: "left", value: "errors", width: "120px", groupable: false },
      ],
      certGenDogsInfoHeaders: [
        { text: "Dog ID", align: "left", value: "dogId" },
        { text: "Deviations", align: "left", value: "certificatesMissing" }, 
        { text: "New", align: "left", value: "certificatesNew" }, 
        { text: "Data errors", align: "left", value: "certificatesExceptions" },    
      ],
      filters: [
        { name: "New", active: false },
        { name: "Deviations", active: false },
        { name: "Data errors", active: false },
      ],
    };
  },
  props: {
  },
  methods: {
    preview: function (executionId: any) {   
      this.displayPrintPreview = true;
      this.displayDogDetails = false;
      this.displayExecutionId = executionId;
      this.Report_Name = "Asca.Api.Reports.rpt8110_Title_Certificate.rdlx";
      this.Report_URL = "/Admin/reports/certificates/"+this.displayExecutionId+"/suffix";
    },
    previewFull: function (executionId: any) {   
      this.displayPrintPreview = true;
      this.displayDogDetails = false;
      this.displayExecutionId = executionId;
      this.Report_Name = "Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx";
      this.Report_URL = "/Admin/reports/certificates/"+this.displayExecutionId+"/prefix";
    },
    previewLabels: function (executionId: any) {
      this.displayPrintPreview = true;
      this.displayDogDetails = false;
      this.displayExecutionId = executionId;
      this.Report_Name = "Asca.Api.Reports.rpt1210_Person_Label.rdlx";
      this.Report_URL = "/Admin/reports/certificates/"+this.displayExecutionId+"/contacts";
    },
    printAgain: function(executionId: any){
      this.displayPrintPreview = true;
      this.displayDogDetails = false;
      this.displayExecutionId = executionId;
      this.Report_Name = "Asca.Api.Reports.rpt8110_Title_Certificate.rdlx";
      this.Report_URL = "/Admin/reports/certificates/"+this.displayExecutionId+"/suffix";
    },
    printAgainFull: function (executionId: any) {   
      this.displayPrintPreview = true;
      this.displayDogDetails = false;
      this.displayExecutionId = executionId;
      this.Report_Name = "Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx";
      this.Report_URL = "/Admin/reports/certificates/"+this.displayExecutionId+"/prefix";
    },
    markPrinted: function (executionId: any) {
      this.$store.dispatch("changeLoaderStatus",true);
      adminTitlingService.markCertGenerationPrinted(executionId, this.userInfo.personId).then((res: any)=>{
        this.$store.dispatch("changeLoaderStatus",false);
        if(res.success){          
          adminTitlingService.getCertGenerationList()
            .then((res: any) => {
              this.certGenInfosList = res;
            });
        } else {
          this.errorMessage = res.messages.join(', ')
        }
      });
    },
    changeFilters: function (index: number) {
      this.filters[index].active = !this.filters[index].active;
      this.filteredCertGenDogsInfosList = [];
      if(!this.filters[0].active && !this.filters[1].active && !this.filters[2].active){
        this.filteredCertGenDogsInfosList = this.certGenDogsInfosList;
      }
      else {
        if(this.filters[0].active){
          var dogsWithNewCerts = this.certGenDogsInfosList.filter(x => !!x.certificatesNew);
          this.filteredCertGenDogsInfosList = this.filteredCertGenDogsInfosList.concat(dogsWithNewCerts);
        }
        if(this.filters[1].active){
          var dogsWithMissingCerts = this.certGenDogsInfosList.filter(x => !!x.certificatesMissing);
          this.filteredCertGenDogsInfosList = this.filteredCertGenDogsInfosList.concat(dogsWithMissingCerts);
        }
        if(this.filters[2].active){
          var dogsWithExceptions = this.certGenDogsInfosList.filter(x => !!x.certificatesExceptions);
          this.filteredCertGenDogsInfosList = this.filteredCertGenDogsInfosList.concat(dogsWithExceptions);
        }
      }
    },
    getProgramInfo: function(){
        this.programInfo = {};
        adminTitlingService.getDogsWithUnprocessedResults(this.selectedProgram)
              .then((res: any) => {
                this.programInfo = res;
              });
  
    },
    processShowResults: function(){ 
      this.$store.dispatch("changeLoaderStatus",true);
        adminTitlingService.processShowResults(this.selectedProgram, this.userInfo.personId)
              .then((res: any) => {
                this.certGenExecutionInfoId = res.certGenExecutionInfoId;
                this.$store.dispatch("changeLoaderStatus",false);
                adminTitlingService.getCertGenerationList()
                  .then((res: any) => {
                    this.certGenInfosList = res;
                  });
              });  
    },
    approve: function(id: number){
        this.$store.dispatch("changeLoaderStatus",true);
        adminTitlingService.approveShowResults(id, this.userInfo.personId)
              .then(() => {
                this.$store.dispatch("changeLoaderStatus",false);
                adminTitlingService.getCertGenerationList()
                  .then((res: any) => {
                    this.certGenInfosList = res;
                  });
              });
    },
    showDogsDetails(certGenExecutionInfo: any){        
        this.displayDogDetails = true;     
        this.displayPrintPreview = false;
        this.selectedGenInfo = certGenExecutionInfo;
        adminTitlingService.getCertGenerationDogsList(certGenExecutionInfo.id)
              .then((res: any) => {
                this.certGenDogsInfosList = res;
                this.filteredCertGenDogsInfosList = res;
              });
    },
  },
  created() {
    adminTitlingService.getCertGenerationList()
      .then((res: any) => {
        this.certGenInfosList = res;
      });
  },
  watch: {
    selectedProgram: function(){
      this.programInfo = {};
      this.displayDogDetails = false;
      this.displayPrintPreview = false;
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    }
  },
});
</script>
